module.exports = __webpack_public_path__ + "img/P38.86b8a097.png";